import React from "react";
import { HEXCheckIcon } from "@icons/hexpert/HEXCheckIcon";
import cs from "classnames";
import './SelectButton.scss';

type SelectButtonProps = {
  name?: string;
  action?: () => void;
  label?: string;
  value?: string | number;
  selected?: boolean;
};

export const SelectButton = ({
  name,
  label,
  value,
  action,
  selected,
}: SelectButtonProps) => {
  return (
    <div className={"c-hex-select-button-container"}>
      <input
        type="radio"
        name={name}
        className={"c-hex-select-button-input"}
        value={value}
        onChange={() => {
          action();
        }}
        checked={selected}
      />
      <div
        className={cs("c-hex-select-button-label-wrapper", {
          "c-hex-select-button-label-wrapper-active": selected,
        })}
      >
        <HEXCheckIcon />
        <label htmlFor={name} className={"c-hex-select-button-label"}>
          {label}
        </label>
      </div>
    </div>
  );
};
